import { exists } from 'base/helpers';
import { LibraryCache } from 'base/library_cache';
import { extractTreeByName } from 'base/webflow/data_attributes';
import { getClassIdToNameMap } from 'base/webflow/helpers';

export const isComponentSchemeless = (slug: string, library: LibraryCache) => {
  const comp = library.getCachedPublicComponentJson(slug, {
    fetchIfMissing: true,
  })?.value;
  if (!comp) {
    return false;
  }

  const rootNode = extractTreeByName(comp, undefined);
  const classIdToNameMap = getClassIdToNameMap(comp.payload.styles);

  if (rootNode.text) return false;

  const classes = rootNode.classes
    .map((classId) => classIdToNameMap.get(classId))
    .filter(exists);

  return classes.some(
    (c) => c === 'U_text-color-alternate' || c === 'U_text-color-white',
  );
};
